<template>
	<div class="click-away" ref="elem"><slot /></div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'

const props = defineProps({
	ignoreClasses: Array,
	eventName: {
		type: String,
		default: 'click',
	},
})
const emit = defineEmits(['away'])
const elem = ref(null)

onMounted(() => {
	document.addEventListener(props.eventName, onEvent)
})

onUnmounted(() => {
	document.removeEventListener(props.eventName, onEvent)
})

function onEvent(e) {
	if (isEventWithinContainer(e)) return
	emit('away', e)
}

function isEventWithinContainer(e) {
	if (props.ignoreClasses?.length > 0) {
		return props.ignoreClasses.some((cls) => e.target.closest(cls))
	}
	return elem.value.contains(e.target)
}
</script>
